<template>
  <div>
    <IconList :list="huaxiangXingweiList" />
  </div>
</template>

<script>
import IconList from "@/components/Mycharts/IconList.vue";

export default {
  name: "YoukeQuntiHuaxiangXingweiJiexi",
  components: {
    IconList
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      huaxiangXingweiList: [
        {
          listName: "性别",
          listIcon: require("../../assets/youkequntihuaxiang/icon1.png")
        },
        {
          listName: "年龄",
          listIcon: require("../../assets/youkequntihuaxiang/icon2.png")
        },
        {
          listName: "停留时间",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon1.png")
        },
        {
          listName: "消费潜力",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon3.png")
        },
        {
          listName: "出游距离",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon5.png")
        }
      ]
    };
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
